<template>
  <div>
    <div id="CreatCodeModal" class="modal fade" style="display: none;" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ modal.modalTitle }}</h4>
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">×</span>
              <span class="sr-only">بستن</span>
            </button>
          </div>
          <form class="form-horizontal" v-on:submit.prevent>
            <div class="modal-body">
              <div class="row d-flex align-items-center mb-5">
                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <input name="" type="text" required v-model="modal.title" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>عنوان اسپینر</label>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <input name="" type="number" required v-model="modal.coin" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>تعداد سکه</label>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <input name="" type="number" required v-model="modal.weight" />
                      <span class="highlight"></span>
                      <span class="bar"></span>
                      <label>وزن</label>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12">
                  <div class="mt-2 mb-2 position-relative">
                    <div class="group material-input">
                      <p>وضعیت</p>
                      <select class="form-control" name="isActive" v-model="modal.isAvailable">
                        <option value="true">فعال</option>
                        <option value="false">غیر فعال</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-shadow" data-dismiss="modal">
                بستن
              </button>
              <button type="submit" class="btn btn-primary" @click="handleClick">
                ذخیره
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modal: {
      username: '',
      phone: '',
      password: null,
    },
  },

  watch: {
    modal(newValue, oldValue) {
      console.log(newValue), console.log(oldValue);
    },
  },
  methods: {
    handleClick() {
      this.modal.access = 'admin';
      this.$emit('clicked', this.modal);
    },
    changeIsActive(event) {
      this.modal.sort = event.target.value;
    },
    removeFiles() {},
    async imageSelected(e) {
      console.log(e.target.id);
      this.image = e.target.files[0];
    },
  },
};
</script>
